import Link from 'components/Globals/Base/Link';
import type { MenuItemProps } from 'interfaces/navigation/Header';
import type { EventData } from 'services/Gtm/entities';
import * as S from './SubmenuStyles';
import { trackOptimizelyEvent } from '@/main/lib/providers/OptimizelyProvider';

interface SubMenuItemProps extends MenuItemProps {
  level: number;
  parentLabel: string;
  trackingData: EventData;
  onItemClick?: any;
}

const SubMenuItem = ({ label, url, subMenu, level, parentLabel, trackingData, onItemClick }: SubMenuItemProps) => (
  <>
    <S.MenuItemSubLi>
      <Link
        href={url || undefined}
        ariaLabel={`Go to ${label}`}
        trackingData={{
          ...trackingData,
          eventAction: `${trackingData.eventAction} - level ${level}`,
          eventLabel: `${parentLabel} > ${label}`,
        }}
        className='submenu-link'
        onMouseUp={onItemClick}
        onClick={() => trackOptimizelyEvent('navigation_topic_menu_click', {})}
      >
        {label}
      </Link>
    </S.MenuItemSubLi>
  </>
);

export default SubMenuItem;
